import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertsService } from '../../../alerts.service';
import { TokenStorageService } from '../../../token-storage.service';
import { AuthService } from '../../../auth.service';
import { LoginCommunicationService } from '../../../login-communication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  constructor(private formBuilder: FormBuilder,
    private loginCommunicationService: LoginCommunicationService,
    private router: Router,
    private alertService: AlertsService,
    private authService: AuthService,
    private tokenStorage: TokenStorageService) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    })
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
      this.router.navigate(['']);
    }
  }

  onUsernameInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toLowerCase();
    this.loginForm.get('username')?.setValue(input.value, { emitEvent: false });
  }

  onSubmit(): void {
    const { username, password } = this.loginForm.value;
    this.authService.login(username, password).subscribe((data: {}) => {
      if (data['returnCode'] == -1) {
        this.alertService.error("Invalid Login Credentials!!!");
      } else {
        this.alertService.success("Login successful!!!");
        this.tokenStorage.saveToken(data['token']);
        this.tokenStorage.saveUser(data);
        this.isLoginFailed = false;
        this.loginCommunicationService.changeLoginStatus("d");
        this.router.navigateByUrl('/')
      }
    });
  }
}
